module.exports = __webpack_public_path__ + "static/media/appstore-1d2.4dd32a61.png";